var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3177_885",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7842 0.595703H0.78418V46.5957H50.7842V0.595703Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3177_885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0067 44.7337C41.2331 44.7337 49.5232 36.4436 49.5232 26.2172C49.5232 15.9908 41.2331 7.70068 31.0067 7.70068C20.7804 7.70068 12.4902 15.9908 12.4902 26.2172C12.4902 36.4436 20.7804 44.7337 31.0067 44.7337Z",
    fill: "#FFA00B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8103 44.0749C36.1206 44.0749 45.2895 34.906 45.2895 23.5957C45.2895 12.2853 36.1206 3.11646 24.8103 3.11646C13.4999 3.11646 4.33105 12.2853 4.33105 23.5957C4.33105 34.906 13.4999 44.0749 24.8103 44.0749Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4386 7.70068H21.5449V25.9052H21.6551L35.2523 25.9053V22.0116H25.4386V7.70068Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d762a78135b04cdceb222f86b5e0a532.svg";
export { ForwardRef as ReactComponent };